import {useIsAndroid} from '@eCommerce/frontend-legacy-shared-library-native';
import {Text} from 'native-base';
import React from 'react';
import {useTheme} from 'styled-components/native';

export interface MaskTitlePropTypes {
  title: string;
  fontSize?: string;
  marginBottom?: string;
  lineHeight?: string;
  uppercase?: boolean;
}

const MaskTitle: React.FC<MaskTitlePropTypes> = props => {
  const {title, fontSize, marginBottom, lineHeight, uppercase} = props;
  const theme = useTheme();
  const {silverSand} = theme.colors;
  const isAndroid = useIsAndroid();

  const shouldShowLineHeight = () => {
    if (isAndroid) {
      return undefined;
    }

    if (!lineHeight) {
      return undefined;
    }

    return '10px';
  };

  return (
    <Text
      color={silverSand}
      fontFamily="body"
      fontWeight={700}
      fontSize={fontSize ?? 1}
      lineHeight={shouldShowLineHeight()}
      marginBottom={marginBottom ?? '7px'}
      textTransform={uppercase ? 'uppercase' : undefined}>
      {title}
    </Text>
  );
};

export default MaskTitle;
